﻿$.fn.dxCtrlContentEnvoiMailing = function custom_dxCtrlContentEnvoiMailing(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailing dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailing(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailing = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivLeft = null
    var $DivRight = null
    var dxAccordionMailing=null
    function mConstruit() {
        container.empty()
        container.css("position", "relative")

        var jauge = null
        if (typeof option.jauge == 'undefined') { jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance") }
        else { jauge = option.jauge }

        if (option.showPrevi) {
            $DivLeft = $("<div style='width:60%;height:100%;position:absolute;top:0;left:0;z-index:0;'/>").appendTo(container)
            $DivRight = $("<div style='width:40%;height:100%;position:absolute;top:0;left:60%;z-index:0;'/>").appendTo(container)
            mConstruitDivRight()
            //var dxEmailPrevi = $("<div/>").appendTo($DivRight).dxCtrlContentEnvoiMailingPrevi({
            //    bddCtrl: option.bddCtrl,
            //    data: option.data,
            //    type: option.type,
            //    showObjet: option.showObjet,
            //    onValueChanged: function () {
            //        dxAccordionMailing.mUpdate()
            //    },
            //    onDisplayModif: function () {
            //        mModifier(dxEmailPrevi)
            //    }
            //}).dxCtrlContentEnvoiMailingPrevi("instance")
        } else {
            $DivLeft = $("<div style='width:100%;height:100%;position:absolute;top:0;left:0;z-index:0;'/>").appendTo(container)
        }

        dxAccordionMailing = $("<div style='height:100%;'/>").appendTo($DivLeft).dxCtrlContentEnvoiMailingAccordion({
            bddCtrl: option.bddCtrl,
            data: option.data,
            type: option.type,
            jauge: jauge,
            //allowModifDest: option.allowModifDest,
            onDemandeEnvoi: option.onDemandeEnvoi,
            onChangeAjoutStop: function () {
                dxEmailPrevi.mUpdate()
            }
        }).dxCtrlContentEnvoiMailingAccordion("instance")

        //if (option.bddCtrl.utiCourant.administrateur == "1" &&
        //    option.bddCtrl.objCptCli.data.domaine_dedie_date_fin != null && option.bddCtrl.objCptCli.data.domaine_dedie_date_fin > parametre.dateNow &&
        //    (option.bddCtrl.objCptCli.data.domaine_dedie == null || option.bddCtrl.objCptCli.data.domaine_dedie == "")) {
        //    notify.mShow({
        //        showTitle: false,
        //        width: 340,
        //        message: function (contentElement, popup) {
        //            contentElement.css("font-size", "100%")
        //            contentElement.css("padding-left", "10px")
        //            $("<div style='text-align:left;'>Vous disposez de l'option <b>domaine dédié</b><br/>mais vous n'avez pas encore configuré celui-ci.<br/>Vous pouvez le faire en cliquant ci-dessous ou via votre menu utilisateur.</div>").appendTo(contentElement)
        //            $("<div style='text-align:left;'>Tant que vous n'aurez pas configuré votre <b>domaine dédié</b>, vos emailings seront envoyé via les domaines mutualisés de " + parametre.nom + ".</div>").appendTo(contentElement)
        //            var $A = $("<a href='javascript:void(0)'>Configurer mon domaine dédié</a>").appendTo(contentElement)
        //            $A.on("click", function (e) {
        //                var dxWizard = $("<div/>").appendTo("body").dxCtrlWizardDomaineDedie({
        //                    bddCtrl: option.bddCtrl,
        //                    onClose: function (e) {
        //                        mConstruit()
        //                    }
        //                })
        //                dxWizard.show()
        //                popup.hide()
        //            })
        //        },
        //        tempoSeconde: 30
        //    })
        //}

    }

    var dxEmailPrevi  = null
    function mConstruitDivRight() {
        $DivRight.empty()
        dxEmailPrevi = $("<div style='overflow:hidden;'/>").appendTo($DivRight).dxCtrlContentEnvoiMailingPrevi({
            bddCtrl: option.bddCtrl,
            data: option.data,
            type: option.type,
            showObjet: option.showObjet,
            onValueChanged: function () {
                dxAccordionMailing.mUpdate()
                if (typeof option.onChange != 'undefined') option.onChange()
            },
            onDisplayModif: function () {
                mModifier(dxEmailPrevi)
            }
        }).dxCtrlContentEnvoiMailingPrevi("instance")
    }

    function mModifier(dxEmailPrevi) {
        var containerPop = container.closest(".dx-overlay-content")
        if (containerPop.length == 0) containerPop = container.closest(".dx-ctrlpagepopupdiv")
        var $Div = $("<div style='position:absolute;width:100%;height:100%;z-index:201;top:0;left:0;padding:2px;'/>").appendTo(containerPop)
        var $DivInner = $("<div style='position:relative;width:100%;height:100%;' class='dx-surface'/>").appendTo($Div)
        var jauge = $("<div/>").appendTo($DivInner).dxCtrlJauge({}).dxCtrlJauge("instance")

        var dxContentEmailBase = $("<div style='height:100%'/>").appendTo($DivInner).dxCtrlContentEmailBase({
            bddCtrl: option.bddCtrl,
            readOnly: false,
            data: option.data,
            showObjet: false,
            saveAuto: true,
            allowFullScreen: true,
            buttonClose: {
                location: 'after',
                widget: 'dxButton',
                visible: true,
                options: {
                    text: 'Fermer',
                    icon:'fas fa-times',
                    focusStateEnabled: false,
                    onClick(e) {
                        e.event.stopPropagation();
                        jauge.mShow()
                        dxContentEmailBase.mStopSaveAuto(function () {
                            option.bddCtrl.mAjaxCall({
                                command: "gethtmlurldataemailbdd",
                                nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                                id: option.bddCtrl.getObjet(option.data).cle()
                            }, function (data) {
                                mConstruitDivRight()
                                //dxVisu.mUpdate(data.urlhtml)
                                //if (typeof option.onChange != 'undefined') option.onChange()
                                dxAccordionMailing.mUpdate()
                                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                                $Div.remove()
                                jauge.mHide()
                            })
                        })
                    }
                }
            },
            onDemandeUrl: function (funcFin) {
                dxContentEmailBase.mSaveAuto(function () {
                    option.bddCtrl.mAjaxCall({ command: "getemailurl", id_com_email_envoi: option.data.id_com_email_envoi }, function (data) {
                        funcFin(data.url)
                    })
                })
            },
            onSave: function () {
                //if (typeof option.onSave != 'undefined') option.onSave()
                //mRempliTaille()
            }
        }).dxCtrlContentEmailBase("instance")
    }

    this.element = function () { return container }

    mConstruit();
}